import { render, staticRenderFns } from "./UploadFileHolder.vue?vue&type=template&id=8688073e"
import script from "./UploadFileHolder.vue?vue&type=script&lang=js"
export * from "./UploadFileHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports